
import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,

    USER_LOGOUT,

    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_REGISTER_FAIL,

    USER_DETAILS_REQUEST,
    USER_DETAILS_SUCCESS,
    USER_DETAILS_FAIL,
    USER_DETAILS_RESET,

    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_SUCCESS,
    USER_UPDATE_PROFILE_FAIL,

    USER_LIST_REQUEST,
    USER_LIST_SUCCESS,
    USER_LIST_FAIL,
    USER_LIST_RESET,

    USER_DELETE_REQUEST,
    USER_DELETE_SUCCESS,
    USER_DELETE_FAIL,


} from '../constants/userConstants'

import { axiosAuthed } from "../auth/createAuthedAxios.ts";



export const login = (username, password) => async (dispatch) => {
    try {
        dispatch({
            type: USER_LOGIN_REQUEST
        })


        const config = {
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
            }
        }

        const { data } = await axiosAuthed.post(
            `${process.env.REACT_APP_HOST_IP}auth/login`,
            { 'username': username, 'password': password },
            config
        )


        dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: data
        })

        document.cookie = `cp=${data.id}; SameSite=${process.env.REACT_APP_COOKIE_SAMESITE}; 
        Secure=${process.env.REACT_APP_COOKIE_SECURE}`



        localStorage.setItem('todoUserInfo', JSON.stringify(data))
        // dispatch(getUserDetails())


    } catch (error) {
        dispatch({
            type: USER_LOGIN_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
        dispatch(logout())


    }
}

export const logout = () => async (dispatch) => {
    localStorage.removeItem('todoUserInfo')
    localStorage.removeItem('todoUserDetails')
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json'
        }
    }
    const { data } = await axiosAuthed.post(
        `${process.env.REACT_APP_HOST_IP}auth/logout`,
        config
    )
    dispatch({ type: USER_LOGOUT })
    dispatch({ type: USER_DETAILS_RESET })
    dispatch({ type: USER_LIST_RESET })

}


export const register = (payload, admin) => async (dispatch) => {
    try {


        dispatch({
            type: USER_REGISTER_REQUEST
        })

        const config = {
            headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json'
            }
        }

        const { data } = await axiosAuthed.post(
            `${process.env.REACT_APP_HOST_IP}auth/`,
            {
                'username': payload.username,
                'email': payload.email,
                'first_name': payload.firstName,
                'last_name': payload.lastName,
                'password': payload.password,
                'role': payload?.role || "guest",
                'phone_number': payload?.phoneNumber || ""
            },
            config
        )

        dispatch({
            type: USER_REGISTER_SUCCESS,
            payload: data
        })
        if (!admin) {
            dispatch(login(payload.username, payload.password))

            localStorage.setItem('todoUserInfo', JSON.stringify(data))
        }

    } catch (error) {
        dispatch({
            type: USER_REGISTER_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}


export const getUserDetails = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: USER_DETAILS_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const { data } = await axiosAuthed.get(
            `${process.env.REACT_APP_HOST_IP}user/`,
            config
        )

        dispatch({
            type: USER_DETAILS_SUCCESS,
            payload: data
        })
        localStorage.setItem('todoUserDetails', JSON.stringify({
            "username":data.username,
            "first_name":data.first_name,
            "id":data.id,
            "role":data.role,
            "email":data.email,
            "last_name":data.last_name,
            "is_active":data.is_active,
            "phone_number":data.phone_number}))


    } catch (error) {
        dispatch({
            type: USER_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
        dispatch(logout())
    }
}


export const updateUserPassword = (password, newPassword) => async (dispatch, getState) => {
    try {
        dispatch({
            type: USER_UPDATE_PROFILE_REQUEST
        })

        

        const config = {
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const { data } = await axiosAuthed.put(
            `${process.env.REACT_APP_HOST_IP}user/password`,
            { 'password': password, 'new_password': newPassword },
            config
        )


        dispatch({
            type: USER_UPDATE_PROFILE_SUCCESS,
            payload: data
        })



    } catch (error) {
        dispatch({
            type: USER_UPDATE_PROFILE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}


export const listUsers = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: USER_LIST_REQUEST
        })

        

        const config = {
            headers: {
                'accept': 'application/json',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const { data } = await axiosAuthed.get(
            `${process.env.REACT_APP_HOST_IP}admin/users`,
            config
        )

        dispatch({
            type: USER_LIST_SUCCESS,
            payload: data
        })


    } catch (error) {
        dispatch({
            type: USER_LIST_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}


export const deleteUser = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: USER_DELETE_REQUEST
        })

        

        const config = {
            headers: {
                'accept': '*/*',
                //Authorization: `Bearer ${todoUserInfo.access_token}`
            }
        }

        const { data } = await axiosAuthed.delete(
            `${process.env.REACT_APP_HOST_IP}admin/users/delete/${id}`,
            config
        )

        dispatch({
            type: USER_DELETE_SUCCESS,
            payload: data
        })
        dispatch(listUsers())


    } catch (error) {
        dispatch({
            type: USER_DELETE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }
}

